import React, { useState } from "react";

interface CloneLevelPopupProps {
  show: boolean;
  onConfirm: (level: string) => void;
  onCancel: () => void;
  isBulk?: boolean;
  count?: number;
}

const LEVELS = ["A1", "A2", "B1", "B2"];

const CloneLevelPopup: React.FC<CloneLevelPopupProps> = ({
  show,
  onConfirm,
  onCancel,
  isBulk = false,
  count = 1,
}) => {
  const [selectedLevel, setSelectedLevel] = useState<string>("");
  const [error, setError] = useState<string>("");

  const handleConfirm = () => {
    if (!selectedLevel) {
      setError("Please select a level.");
      return;
    }
    onConfirm(selectedLevel);
    setSelectedLevel("");
    setError("");
  };

  const handleCancel = () => {
    setSelectedLevel("");
    setError("");
    onCancel();
  };

  if (!show) return null;

  return (
    <div
      className="modal"
      role="dialog"
      style={{
        display: "block",
        position: "fixed",
        zIndex: 100000,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <div className="modal-dialog" style={{ marginTop: "15vh" }}>
        <div
          className="modal-content"
          style={{ borderRadius: "24px", padding: "6px" }}
        >
          <div className="modal-body">
            <h5
              style={{
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "6px",
              }}
            >
              {isBulk
                ? `Clone ${count} Question${count > 1 ? "s" : ""}`
                : "Clone Question"}
            </h5>
            <p
              style={{
                textAlign: "center",
                color: "#666",
                fontSize: "14px",
                marginBottom: "16px",
              }}
            >
              Select the level for the cloned question{count > 1 ? "s" : ""}
            </p>

            {/* Level buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                flexWrap: "wrap",
                marginBottom: "8px",
              }}
            >
              {LEVELS.map((level) => (
                <button
                  key={level}
                  type="button"
                  className="btn user"
                  onClick={() => {
                    setSelectedLevel(level);
                    setError("");
                  }}
                  style={{
                    width: "70px",
                    height: "44px",
                    borderRadius: "10px",
                    fontSize: "15px",
                    fontWeight: 600,
                    border:
                      selectedLevel === level
                        ? "2px solid #7542E4"
                        : "1px solid #D9D9D9",
                    backgroundColor:
                      selectedLevel === level ? "#f0ebff" : "#fff",
                    color:
                      selectedLevel === level ? "#7542E4" : "#100F15",
                    transition: "all 0.15s",
                  }}
                >
                  {level}
                </button>
              ))}
            </div>

            {/* Validation error */}
            {error && (
              <p
                style={{
                  color: "#EB002C",
                  fontSize: "13px",
                  textAlign: "center",
                  marginBottom: "4px",
                }}
              >
                {error}
              </p>
            )}
          </div>

          <div className="modal-body d-flex justify-content-between">
            <button
              type="button"
              className="btn user"
              onClick={handleCancel}
              style={{
                height: "50px",
                color: "#100F15",
                background: "none",
                border: "1px solid #100F15",
                borderRadius: "10px",
                fontSize: "14px",
                width: "auto",
                padding: "14px 35px",
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn user"
              onClick={handleConfirm}
              style={{
                height: "50px",
                backgroundColor: "#7542E4",
                color: "#fff",
                borderRadius: "10px",
                fontSize: "14px",
                width: "auto",
                padding: "14px 35px",
                border: "none",
              }}
            >
              Clone
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloneLevelPopup;
